// A local safety copy of an in-progress form. The server draft is the real
// autosave; this exists for the window before the first server save succeeds
// (offline, a 409, a crash mid-request). Every call swallows storage errors —
// a full or blocked localStorage must never break the form it is protecting.

const PREFIX = "rdc:draft:";

function storage() {
    try {
        if (typeof window === "undefined" || !window.localStorage) return null;
        return window.localStorage;
    } catch (_) {
        return null;
    }
}

export function draftBackupKey(...parts) {
    return PREFIX + parts.map((p) => String(p == null ? "" : p)).join(":");
}

export function saveDraftBackup(key, values, extra = {}) {
    const ls = storage();
    if (!ls || !key) return false;
    try {
        ls.setItem(key, JSON.stringify({ values, savedAt: Date.now(), ...extra }));
        return true;
    } catch (_) {
        return false;
    }
}

export function loadDraftBackup(key) {
    const ls = storage();
    if (!ls || !key) return null;
    try {
        const raw = ls.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object" || !parsed.values) return null;
        return parsed;
    } catch (_) {
        return null;
    }
}

export function clearDraftBackup(key) {
    const ls = storage();
    if (!ls || !key) return;
    try {
        ls.removeItem(key);
    } catch (_) {
        // nothing to do
    }
}
